import axios, {AxiosResponse} from 'axios';

export const namespace = (): string => {
	return `${ window.measurementSelectorVariables.restUrl }kps/v1/configuration`;
};

export const RetrieveConfiguration = async ( short_link: string ): Promise<AxiosResponse> => {
	return axios.get( `${namespace()}/get/`, { params: { short_link: encodeURIComponent( short_link ) } } );
};

export const StoreConfiguration = async ( baseUrl: string, configuration: string, isTemporary = false, action: string, name: string ): Promise<AxiosResponse> => {
	return await axios.post( `${namespace()}/create/`, { baseUrl, configuration, isTemporary, action, name }, {
		headers: {
			'X-WP-Nonce': window.measurementSelectorVariables.restNonce,
		}
	} );
};
